import type { Components } from '@mui/material/styles';

export default function MuiStepContent(): Components['MuiStepContent'] {
  return {};
}
